import React from "react"
import { CheckboxIcon, CheckboxLabel } from "./Input.styled"
import { ReactComponent as CheckIcon } from "images/icons/circle-check.svg"
import { ReactComponent as XmarkIcon } from "images/icons/circle-xmark.svg"

type Props = {
  label: string
  value: boolean
  description?: string
}

const FallbackCheckbox = ({ label, value, description }: Props) => {
  return (
    <CheckboxLabel $booleanValue={value}>
      <div>
        <div>{label}</div>
        {description && <span>{description}</span>}
      </div>
      <CheckboxIcon>{value ? <CheckIcon /> : <XmarkIcon />}</CheckboxIcon>
    </CheckboxLabel>
  )
}

export default FallbackCheckbox
